import axios from 'axios'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import DatePickers from './DatePickers'
import OrderForm from './OrderForm'
import OrdersStats from './OrdersStats'
import OrdersTable from './OrdersTable'
import jwtDecode from 'jwt-decode'
import { Button } from 'reactstrap'
import { qualityDepartment, retentionDepartments } from './EnumOrder'
import checkOrder from './checkOrder'
import { Checkbox } from '@material-ui/core'

const Orders = ({ type }) => {
  const [data, setData] = useState([])
  const [ordersData, setOrdersData] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const token = localStorage.getItem('token')
  const decodedToken = token ? jwtDecode(token) : null
  const user_level = decodedToken?.user_level || ''
  const loggedUserDepartment = decodedToken?.department[0] || ''
  const isQualityUser = loggedUserDepartment.includes(qualityDepartment)
  const isRetentionUser = retentionDepartments.includes(loggedUserDepartment)
  const canViewCheckbox = isQualityUser || isRetentionUser || user_level === 1

  const handleCheckboxChange = async (orderId) => {
    try {
      const data = await checkOrder(orderId)
      setOrdersData((prevOrders) =>
        prevOrders.map((order) => (order._id === orderId ? { ...order, checked: data.updatedOrder.checked } : order))
      )
    } catch (err) {
      console.error('Error checking order:', err)
    }
  }

  const buildTableData = (orders) => {
    return orders.map((d) => {
      const checkboxColumn =
        canViewCheckbox && retentionDepartments.includes(d.user_id.department[0]) ? (
          <Checkbox checked={Boolean(d.checked)} disabled={isRetentionUser} onChange={() => handleCheckboxChange(d._id)} color='primary' />
        ) : canViewCheckbox ? (
          <span></span>
        ) : null

      const row = [
        `${d.user_id.first_name} ${d.user_id.last_name} ${qualityDepartment.includes(d.user_id.department[0]) ? '(From Quality)' : ''}`,
        d.order_type.name,
        d.order_type?.category?.name,
        d.order_id,
        isQualityUser ? 'Yes' : 'No',
        d.activation_date ? moment(d.activation_date).format('DD/MM/YYYY') : 'N/A',
        checkboxColumn,
        d.checked ? 'Yes' : 'No',
        <Link to={`/editOrder/${d._id}`} key={d._id}>
          <Button outline className='mb-1' color='warning' type='button'>
            <span>Modifiko</span>
          </Button>
        </Link>
      ]

      return row.filter((item) => item !== null)
    })
  }

  const fetchOrders = async () => {
    setLoading(true)
    try {
      const { data } = await axios.get(type === 'user' ? 'orders/getUserOrders' : 'orders')
      if (data.success) {
        setOrdersData(data.orders)
        setData(buildTableData(data.orders))
      }
    } catch (e) {
      console.log('error', e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchOrders()
  }, [])

  useEffect(() => {
    if (ordersData.length > 0) {
      setData(buildTableData(ordersData))
    }
  }, [ordersData])

  return (
    <div>
      <div className='content-heading d-flex justify-content-between'>
        <div>Orders</div>
      </div>
      {user_level === 4 && !isQualityUser ? '' : <DatePickers />}
      {type == 'user' && (
        <div>
          <OrderForm setOrders={setData} user={decodedToken} />
        </div>
      )}{' '}
      {type == 'all' && <OrdersStats />}
      {!loading && (
        <OrdersTable orders={data} type={type} canViewCheckbox={canViewCheckbox} loading={loading} page={page} setPage={setPage} />
      )}
    </div>
  )
}

export default Orders
